import React, { useState } from 'react';
import { getImagePath } from "../../utils/constants";

type BankSelectModalProps = {
    onClose: () => void;
    onSelect: (bankCode: string, bankName: string) => void;
};

type Bank = {
    code: string;
    name: string;
    displayName: string;
    image: string;
};

const BANKS: Bank[] = [
    { code: '002', name: 'KDB산업은행', displayName: 'KDB산업', image: 'bank002.png' },
    { code: '003', name: '기업은행', displayName: 'IBK기업', image: 'bank003.png' },
    { code: '004', name: '국민은행', displayName: 'KB국민', image: 'bank004.png' },
    { code: '007', name: '수협은행', displayName: '수협', image: 'bank007.png' },
    { code: '011', name: 'NH농협은행', displayName: 'NH농협', image: 'bank011.png' },
    { code: '012', name: '농협중앙회', displayName: '지역농협', image: 'bank012.png' },
    { code: '020', name: '우리은행', displayName: '우리', image: 'bank020.png' },
    { code: '023', name: 'SC제일은행', displayName: 'SC제일', image: 'bank023.png' },
    { code: '027', name: '한국씨티은행', displayName: '씨티', image: 'bank027.png' },
    { code: '031', name: '대구은행', displayName: '대구', image: 'bank031.png' },
    { code: '032', name: '부산은행', displayName: '부산', image: 'bank032.png' },
    { code: '034', name: '광주은행', displayName: '광주', image: 'bank034.png' },
    { code: '035', name: '제주은행', displayName: '제주', image: 'bank035.png' },
    { code: '037', name: '전북은행', displayName: '전북', image: 'bank037.png' },
    { code: '039', name: '경남은행', displayName: '경남', image: 'bank039.png' },
    { code: '045', name: '새마을금고', displayName: '새마을금고', image: 'bank045.png' },
    { code: '048', name: '신협', displayName: '신협', image: 'bank048.png' },
    { code: '050', name: '저축은행', displayName: '저축', image: 'bank050.png' },
    { code: '064', name: '산림조합중앙회', displayName: '산림조합', image: 'bank064.png' },
    { code: '071', name: '우체국', displayName: '우체국', image: 'bank071.png' },
    { code: '081', name: '하나은행', displayName: '하나', image: 'bank081.png' },
    { code: '088', name: '신한은행', displayName: '신한', image: 'bank088.png' },
    { code: '089', name: '케이뱅크', displayName: '케이뱅크', image: 'bank089.png' },
    { code: '090', name: '카카오뱅크', displayName: '카카오뱅크', image: 'bank090.png' },
    { code: '092', name: '토스뱅크', displayName: '토스뱅크', image: 'bank092.png' },
    { code: '103', name: 'SBI저축은행', displayName: 'SBI저축', image: 'bank103.png' },
];

const SECURITIES: Bank[] = [
    { code: '209', name: '유안타증권', displayName: '유안타', image: 'bank209.png' },
    { code: '238', name: '미래에셋증권', displayName: '미래에셋', image: 'bank238.png' },
    { code: '240', name: '삼성증권', displayName: '삼성', image: 'bank240.png' },
    { code: '243', name: '한국투자증권', displayName: '한국투자', image: 'bank243.png' },
    { code: '247', name: 'NH투자증권', displayName: 'NH투자', image: 'bank247.png' },
    { code: '266', name: 'SK증권', displayName: 'SK', image: 'bank266.png' },
    { code: '267', name: '대신증권', displayName: '대신', image: 'bank267.png' },
    { code: '278', name: '신한금융투자', displayName: '신한투자', image: 'bank278.png' },
    { code: '280', name: '유진투자증권', displayName: '유진투자', image: 'bank280.png' },
    { code: '287', name: '메리츠증권', displayName: '메리츠증권', image: 'bank287.png' },
    { code: '099', name: '금융결제원', displayName: '금융결제원', image: 'bank099.png' },
];

const BankSelectModal: React.FC<BankSelectModalProps> = ({ onClose, onSelect }) => {
    const [activeTab, setActiveTab] = useState<'bank' | 'securities'>('bank');

    const handleBankClick = (bank: Bank) => {
        onSelect(bank.code, bank.name);
    };

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <>
            <div className="modal show" id="myModal" style={{ display: 'block' }} onClick={handleBackdropClick}>
                <div className="modal-dialog ver2">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button
                                className="modal-close-rectangle e1o9xxx63"
                                onClick={onClose}
                            >
                                <svg width="40" height="4" viewBox="0 0 40 4" fill="none">
                                    <rect width="40" height="4" rx="2" fill="#D2D5D6"></rect>
                                </svg>
                            </button>
                        </div>
                        <div className="normal-tabs-wrap">
                            <ul className="normal-tabs col2">
                                <li
                                    className={`tab-link ${activeTab === 'bank' ? 'current' : ''}`}
                                    onClick={() => setActiveTab('bank')}
                                >
                                    은행
                                </li>
                                <li
                                    className={`tab-link ${activeTab === 'securities' ? 'current' : ''}`}
                                    onClick={() => setActiveTab('securities')}
                                >
                                    증권사
                                </li>
                            </ul>
                        </div>

                        {/* 은행 탭 */}
                        <div
                            id="tab-1"
                            className={`normal-tab-content ${activeTab === 'bank' ? 'current' : ''}`}
                            style={{ display: activeTab === 'bank' ? 'block' : 'none' }}
                        >
                            <div className="bank-wrap-scroll">
                                <ul className="bank-list">
                                    {BANKS.map((bank) => (
                                        <li key={bank.code}>
                                            <button
                                                type="button"
                                                className="corp-item"
                                                onClick={() => handleBankClick(bank)}
                                            >
                                                <div className="corp-item-icon">
                                                    <img src={getImagePath(bank.image)} alt={bank.name} />
                                                    <span className="blind">{bank.name}</span>
                                                </div>
                                                <span className="corp-name">{bank.displayName}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* 증권사 탭 */}
                        <div
                            id="tab-2"
                            className={`normal-tab-content ${activeTab === 'securities' ? 'current' : ''}`}
                            style={{ display: activeTab === 'securities' ? 'block' : 'none' }}
                        >
                            <div className="bank-wrap-scroll">
                                <ul className="bank-list">
                                    {SECURITIES.map((security) => (
                                        <li key={security.code}>
                                            <button
                                                type="button"
                                                className="corp-item"
                                                onClick={() => handleBankClick(security)}
                                            >
                                                <div className="corp-item-icon">
                                                    <img src={getImagePath(security.image)} alt={security.name} />
                                                    <span className="blind">{security.name}</span>
                                                </div>
                                                <span className="corp-name">{security.displayName}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </>
    );
};

export default BankSelectModal;